module.exports = __webpack_public_path__ + "static/media/white heading and icon horizontal.59b376a5.svg";